<template>
<div class="chapter">
<div class="inner_page">
<p><a id="als"></a></p>
<div class="fmhT">Also by David Gessner</div>
<div class="ctag1"><i>My Green Manifesto</i> <br/><i>The Prophet of Dry Hill</i> <br/><i>Return of the Osprey</i> <br/><i>Sick of Nature</i> <br/><i>Soaring with Fidel</i> <br/><i>Under the Devil’s Thumb</i> <br/><i>A Wild, Rank Place</i></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// davi_9781571318398_oeb_als_r1.vue?0b6ab34c